import SharedDataGrid from 'components/data-grid';
import { styled } from '@mui/material/styles';
import React from 'react';

import { ChartPalette } from 'components/charts/types/chart-palette.type';

type Props = React.ComponentProps<typeof SharedDataGrid> & {
  chartPalette: ChartPalette;
};

const DATA_LAB_GRID_BAND_HEIGHT = 40;

const StyledDataGrid = styled(SharedDataGrid, {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ chartPalette }) => ({
  '&.MuiDataGrid-root': {
    border: `1px solid ${chartPalette.borders.subtle}`,
    '& svg': { color: chartPalette.text.secondary },
  },
  '& .MuiDataGrid-columnHeaders': {
    '& .MuiDataGrid-filler': { backgroundColor: `${chartPalette.backgrounds.sunken} !important` },
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: chartPalette.backgrounds.sunken,
    color: chartPalette.text.primary,
    borderRight: `1px solid ${chartPalette.borders.subtle}`,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    color: chartPalette.text.primary,
  },
  '& .MuiDataGrid-cell': {
    borderTop: `1px solid ${chartPalette.borders.subtle}`,
    borderRight: `1px solid ${chartPalette.borders.subtle}`,
    color: chartPalette.text.primary,
    '&.cell--disabled': { backgroundColor: `${chartPalette.backgrounds.sunken} !important` },
  },
  '& .MuiDataGrid-row': {
    backgroundColor: chartPalette.backgrounds.surface,
    '&:hover': { backgroundColor: chartPalette.backgrounds.raised },
    '&.even': { backgroundColor: chartPalette.backgrounds.surface },
    '&.odd': { backgroundColor: chartPalette.backgrounds.sunken },
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `1px solid ${chartPalette.borders.subtle}`,
    color: chartPalette.text.secondary,
  },
  '& .MuiDataGrid-overlay': {
    backgroundColor: 'transparent',
  },
}));

const DataLabDataGrid: React.FC<Props> = ({ chartPalette, ...props }) => (
  <StyledDataGrid
    chartPalette={chartPalette}
    {...props}
    rowHeight={DATA_LAB_GRID_BAND_HEIGHT}
    columnHeaderHeight={DATA_LAB_GRID_BAND_HEIGHT}
  />
);

export default DataLabDataGrid;
